module.exports = __webpack_public_path__ + "static/app_bg_loading-825cf754e50f385b743504b2713ffaf8.gif";